import React from 'react';

import { Portal } from '@chakra-ui/react';

import { Menu, MenuButton, MenuItem, MenuList } from 'uiToolkitV1/MenuV2';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { GenericControl, ReadOnlyGenericControl } from './GenericControl';

/* expect value in format {value, label} */
export const SelectV2 = ({
  onSelect,
  menuItems,
  selectedItem,
  valueKey = 'value',
  labelKey = 'label',
  renderMenuItem = (menuItem) => <TextBodyMedium> {menuItem?.[labelKey]} </TextBodyMedium>,
  renderControlItem = renderMenuItem,
  isMenuItemSelected = (menuItem) => menuItem?.[valueKey] === selectedItem?.[valueKey],
  renderAs = GenericControl,
  isReadOnly = false /* isReadOnly takes priority over renderAs */,
  menuButtonProps = {},
  menuListProps = {},
  usePortal = false,
  ...props
}) => {
  const as = isReadOnly ? ReadOnlyGenericControl : renderAs;

  return (
    <Menu matchWidth {...props}>
      <MenuButton as={as} {...menuButtonProps}>
        {renderControlItem(selectedItem)}
      </MenuButton>
      {usePortal ? (
        <Portal>
          <MenuListComponent
            /* zIndex is necessary */
            menuListProps={{ ...menuListProps, zIndex: 'tooltip' }}
            menuItems={menuItems}
            valueKey={valueKey}
            isMenuItemSelected={isMenuItemSelected}
            onSelect={onSelect}
            renderMenuItem={renderMenuItem}
          />
        </Portal>
      ) : (
        <MenuListComponent
          menuListProps={menuListProps}
          menuItems={menuItems}
          valueKey={valueKey}
          isMenuItemSelected={isMenuItemSelected}
          onSelect={onSelect}
          renderMenuItem={renderMenuItem}
        />
      )}
    </Menu>
  );
};

const MenuListComponent = ({ menuListProps, menuItems, valueKey, isMenuItemSelected, onSelect, renderMenuItem }) => (
  <MenuList overflow="auto" maxHeight="50vh" {...menuListProps}>
    {menuItems.map((menuItem) => (
      <MenuItem
        key={menuItem?.[valueKey]}
        isSelected={isMenuItemSelected(menuItem)}
        onClick={() => onSelect(menuItem)}
        isDisabled={menuItem?.isDisabled}
      >
        {renderMenuItem(menuItem)}
      </MenuItem>
    ))}
  </MenuList>
);
